import React from "react";
import List from "./list";

const ListList = ({lists}) => {
    return(
        <>
            {lists.map((list, index) =>
                <List number={index +1} list={list} key={list.id} />
            )}
        </>
    )
}

export default ListList;